import React from 'react';
import AppContext from './context/AppContext';
import UseAppContext, { providerPropTypes } from './hooks/UseAppContext';
import Loader from './components/Loader';
import TeamsList from './components/TeamsList';

function App() {
  const appContextValue = UseAppContext();

  return (
    <AppContext.Provider value={appContextValue}>
      <Loader>
        <TeamsList />
      </Loader>
    </AppContext.Provider>
  );
}

AppContext.Provider.propTypes = providerPropTypes;

export default App;
